import {Route, Routes} from "react-router-dom";
import {Suspense, useContext} from "react";
import PrivateRoute from "context/PrivateRoute";
import HomeManager from "views/HomeManager";
import NotFound from "views/NotFound";
import NotFoundOrganization from "views/NotFoundOrganization";
// -
import Login from "views/auth/Login";
import InvitationPassword from "views/auth/InvitationPassword";
import RoutesAssetManagement from "views/asset-management/RoutesAssetManagement";
import Recovery from "views/auth/Recovery";
import ChangePassword from "views/auth/ChangePassword";
import RenewPassword from "views/auth/RenewPassword";
import RoutesDevicesConfiguration from "views/device-configuration/RoutesDevicesConfiguration";
import RoutesDataViews from "views/data-view/RoutesDataViews";
import RoutesManagement from "views/route-management/RoutesManagement";
import RoutesReports from "views/reports/RoutesReports";
import RoutesAdvanced from "views/advanced/RoutesAdvanced";
import RoutesNotifications from "views/notifications/RoutesNotifications";
import RoutesMaintenance from "views/maintenance/RoutesMaintenance";
import RoutesAdministration from "views/admin/RoutesAdministration";
import RoutesFleetManagement from "views/fleet-management/RoutesFleetManagement";
import RoutesAlerts from "views/alerts/RoutesAlerts";
import RoutesHistoric from "views/historic/RoutesHistoric";
import RoutesQuestion from "views/question/RoutesQuestion";
import Profile from "views/Profile";

import RoutesHidden from "views/hidden/RoutesHidden";
import RoutesProcess from "views/process/RoutesProcess";

const AppRoutes = () => {
    return (
        <Suspense fallback={<div>Loading....</div>}>
            <Routes>
                <Route
                    path="/"
                    element={
                        <PrivateRoute>
                            <HomeManager />
                        </PrivateRoute>
                    }
                />
                {RoutesQuestion()}
                {RoutesAssetManagement()}
                {RoutesDevicesConfiguration()}
                {RoutesDataViews()}
                {RoutesManagement()}
                {RoutesReports()}
                {RoutesNotifications()}
                {RoutesAdvanced()}
                {RoutesAlerts()}
                {RoutesMaintenance()}
                {RoutesHidden()}
                {RoutesAdministration()}
                {RoutesFleetManagement()}
                {RoutesProcess()}
                {RoutesHistoric()}

                <Route
                    path="profile"
                    element={
                        <PrivateRoute>
                            <Profile />
                        </PrivateRoute>
                    }
                />
                <Route path="login" element={<Login />} />
                <Route path="recovery" element={<Recovery />} />
                <Route path="recovery/password/:token" element={<ChangePassword />} />
                <Route path="invitation/:token" element={<InvitationPassword />} />
                <Route path="renew/password/:token" element={<RenewPassword />} />

                {/* ALWAYS AT THE END */}
                <Route path="404" element={<NotFound />} />
                <Route path="notorgpanel" element={<NotFoundOrganization />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    );
};
export default AppRoutes;
